var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.9543 0 0 8.95431 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#0077B5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17861_265307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9941 30.0003V29.9995H29.9991V22.6645C29.9991 19.0762 29.2266 16.312 25.0316 16.312C23.0149 16.312 21.6616 17.4187 21.1091 18.4678H21.0507V16.647H17.0732V29.9995H21.2149V23.3878C21.2149 21.647 21.5449 19.9637 23.7007 19.9637C25.8249 19.9637 25.8566 21.9503 25.8566 23.4995V30.0003H29.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3301 16.647H14.4767V29.9995H10.3301V16.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4017 10C11.0758 10 10 11.0758 10 12.4017C10 13.7275 11.0758 14.8258 12.4017 14.8258C13.7275 14.8258 14.8033 13.7275 14.8033 12.4017C14.8025 11.0758 13.7267 10 12.4017 10V10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17861_265307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.b9add4df4898ca1adc818c8cbeefdee7.svg";
export { ForwardRef as ReactComponent };